<template>
    <div>
        <div :class="['comment-footer', isFromAlbum && 'comment-footer-album']" data-spm="comment-reply">
            <!-- 头像 -->
            <a class="avatar-container" :href="loginHref" data-spm-data="avatar">
                <img class="avatar" :src="avatar" />
                <div :class="['red-pot', showRedPotCount < 10 && 'red-pot-little']" v-if="showRedPotCount">
                    {{ setCount(showRedPotCount) }}</div>
            </a>
            <div class="line"></div>
            <!-- 评论按钮 -->
            <CommentInput 
                ref="commentInput" 
                data-spm-data="2" 
                :articleId="articleId" 
                :accountId="accountId"
                :articleTitle="articleTitle" 
                :placeholder="btnText" 
                :isLogin="isLogin" 
                @toast="handleToast"
                @submit="handleSubmit">
            </CommentInput>
            <!-- 评论 -->
            <a class="icons-c" :href="commentHref" data-spm-data="3" style="marginLeft:10px">
                <div class="commnet-icon" />
                <div class="count" v-if="commentCount">{{ setCount(commentCount) }}</div>
            </a>
            <!-- 点赞 -->
            <div class="icons-c" @click="changeLike" data-spm-data="4" v-if="canShowLike">
                <div :class="[isLiked ? 'like-icon' : 'no-like-icon']" />
                <div class="count" v-if="likeCount">{{ setCount(likeCount) }}</div>
            </div>
            <!-- 收藏 -->
            <collection-button :collectionData="collectionData" />
            <!-- 分享 -->
            <div class="share-icon i-share" @click="handleShare" data-spm-acode="3031" data-spm-data="5"></div>
        </div>
        <DialogLogin v-if="showDialogLogin" @closeDialogLogin="handleShowDialogLogin" />
    </div>
</template>

<script>
import { handleLike, getInteractionCountApi, syncLikeArticle } from '../../js/article-main/request/api'
import localStorageUtil from '../../utils/localstorageUtil'
import DialogLogin from './dialog-login.vue'
import { sendAction } from '@/utils/spmUtil'
import { acodeConfig } from '@/config/spmConfig'
import Utils from "@/utils/util"
import { getUnreadMessageCount } from '@/utils/request'
import CollectionButton from '@/vue_components/collection-button.vue'
import CommentInput, { eventEmitter, eventNameMap } from 'common-components/lib/commentInput/index'
import 'common-components/lib/commentInput/index.css'

const UA = navigator.userAgent.toLowerCase();
const isQQ = (UA.indexOf("mqqbrowser/") > -1) && (UA.indexOf("micromessenger") === -1) && (UA.indexOf("sogoumse/") === -1)
const isUC = (UA.indexOf("ucbrowser/") > -1)

export default {
    name: "FooterComment",
    props: ['from'],
    components: {
        DialogLogin, // 首次点赞弹窗
        CollectionButton,
        CommentInput,
    },
    data() {
        return {
            showDialogLogin: false, // 首次点赞登录弹窗
            btnText: '分享见解',
            userInfo: '',
            isLogin: false,
            commentHref: '',
            loginHref: '',
            likeCount: 0,
            commentCount: 0,
            isLiked: '',
            avatar: "https://statics.itc.cn/msfe/pictures/avatar_unlogin@2x.png",
            noLikeImg: "",
            likedImg: "",
            commentImg: "https://statics.itc.cn/mptc-mpfe/img/article/icon_comment.png",
            showRedPotCount: 0, //红点通知
            collectionData: {
                isCollection: false, // 收藏状态
                collectionCount: 0, // 收藏数量

            }
        };
    },
    mounted() {
        this.getUserInfo()
        this.getInteractionCount() // 获取评论、点赞、收藏数量
        this.getCommentHref()
        this.getLoginHref()
        this.addBreath()
        if (window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
            setTimeout(function () {
                window.sohuSpm.domDidChange({ target: 'comment-reply' });
            }, 100)
        }
        window.eventBus.$on('showCommentTextarea', () => {
            eventEmitter.emit(eventNameMap.showCommentPopup)
        })
    },
    computed: {
        // 来自图集页
        isFromAlbum() {
            return this.from == 'album'
        },
        // A级别文章展示“点赞”
        canShowLike() {
            return window.cfgs?.Sgrade == 0
        },
        articleId() {
            return window.cfgs?.newsId
        },
        accountId() {
            return window.cfgs?.media_id
        },
        articleTitle() {
            return window.cfgs?.title
        },
    },
    methods: {
        handleShowDialogLogin(status) {
            this.showDialogLogin = status ? true : false
        },
        // 发布成功，评论数+1
        addCommentCount() {
            this.commentCount = this.commentCount + 1
        },
        // 获取互动数量
        async getInteractionCount() {
            try {
                if (this.isLogin) await syncLikeArticle()
                let res = await getInteractionCountApi()
                if (res.code == 1 && res.data) {
                    let countObj = res?.data?.[`mp_${window.cfgs?.newsId}`]
                    // 评论数
                    this.commentCount = countObj[99]?.totalCount + countObj[98]?.totalCount // 98：审核中的评论数
                    // 点赞
                    this.isLiked = countObj[12]?.optionInfos?.[0]?.operated
                    this.likeCount = countObj[12]?.optionInfos?.[0]?.count
                    // 收藏
                    this.collectionData = {
                        isCollection: countObj[11]?.optionInfos?.[0]?.operated,
                        collectionCount: countObj[11]?.optionInfos?.[0]?.count
                    }
                }
            } catch (error) { }
        },
        getUserInfo() {
            this.userInfo = window.userInfo
            if (this.userInfo?.avatar || this.userInfo?.userId) {
                this.isLogin = true
                localStorageUtil.removeItem('isFirstThumb')
                this.avatar = this.userInfo?.avatar
            }
        },
        timeOutFunc(delay = 1000) {
            return new Promise(resolve => setTimeout(resolve, delay));
        },
        // 增加微信呼吸特效
        addBreath() {
            this.$nextTick(() => {
                var shareElements = document.getElementsByClassName("i-share");
                var shareEle = shareElements && shareElements[0];
                if (shareEle) {
                    this.timeOutFunc(5000).then(() => {
                        shareEle.style.transition = " all ease-in-out 0.6s "
                        shareEle.style.background = "url(https://statics.itc.cn/mptc-mpfe/img/article/icon_wechat3.png)"
                        shareEle.style.backgroundSize = "contain"
                        var internalId = setInterval(() => {
                            shareEle.style.transform = "scale(1.3)";
                            var timeOut = setTimeout(() => {
                                shareEle.style.transform = "scale(1)";
                                clearTimeout(timeOut)
                            }, 600)
                        }, 1200)
                        var shutDown = setTimeout(() => {
                            clearInterval(internalId)
                            clearTimeout(shutDown)
                            shareEle.style.transform = "none";
                            shareEle.style.removeProperty('background')
                            shareEle.style.removeProperty('backgroundSize')
                            shareEle.style.removeProperty('transition')
                        }, 4800); // 关闭呼吸效果，清除定时器
                    })
                }
            })
        },
        handleShare() {
            // 使用浏览器原生分享面板(除uc&qq)
            if (navigator.canShare && navigator.share && !isQQ && !isUC) {
                const windowUrl = window.location.href
                const urlWithTrans = window.location.origin + window.location.pathname + '?_trans_=010004_zyllqxtmrfx'
                history.replaceState(null, null, urlWithTrans) // 浏览器分享url取自window.location.href,这里手动加上trans码
                sendAction({
                    acode: acodeConfig.shareAction,
                    clkParam: 'shareCode:browser'
                })
                navigator.share({
                    title: document.title,
                    text: window?.cfgs?.description,
                    url: urlWithTrans,
                }).then(() => {
                    history.replaceState(null, null, windowUrl) // 恢复默认url
                }).catch(() => {
                    history.replaceState(null, null, windowUrl) // 恢复默认url
                })
            } else {
                window.h5_sohu.plugin.api.call('show_share', {}, function () { });
            }
        },
        changeLike: Utils.debounce(async function () {
            sendAction({
                acode: '9141',
                clkParam: `s:${+(!this.isLiked)},p:1`
            });
            try {
                const res = await handleLike(!this.isLiked)
                if (res.code == 1) {
                    this.isLiked = !this.isLiked
                    this.likeCount = res.data
                    if (this.isLiked) this.$refs?.plusOne?.classList.add('plusOneDynamic')//增加动效
                    else this.$refs?.plusOne?.classList.remove('plusOneDynamic')//移除动效
                }

                //  每天首次点赞出登录弹窗
                let isFirstThumb = localStorageUtil.getItem('isFirstThumb')
                if (!isFirstThumb && this.isLiked && !this.isLogin) {
                    // 展示登录弹窗
                    this.handleShowDialogLogin(true)
                    // 第二天消失
                    var currentTime = new Date().getTime();
                    var targetTime = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)).getTime()// 设置目标时间为今天晚上12点
                    var remainingMilliseconds = targetTime - currentTime // 计算剩余毫秒数
                    localStorageUtil.setItem('isFirstThumb', remainingMilliseconds)
                }
            } catch (error) { console.log(error) }
        }, 200),
        getLoginHref() {
            let env = Utils.getEnvironment(); // 获取运行环境
            // 未登录
            if (!this.isLogin) {
                const loginHost = {
                    test: "https://test-m.sohu.com/login?type=1&origin=1",
                    pre: "https://pre-m.sohu.com/login?type=1&origin=1",
                    prod: "https://m.sohu.com/login?type=1&origin=1",
                }
                this.loginHref = Utils.addQueryArgs(loginHost[env], {
                    r: encodeURIComponent(window.location.href),
                })
            } else {
                const ucenterHost = {
                    test: "//test-m.sohu.com/ucenter",
                    pre: "//pre-m.sohu.com/ucenter",
                    prod: "//m.sohu.com/ucenter",
                }
                this.loginHref = Utils.addQueryArgs(ucenterHost[env], {
                    r: encodeURIComponent(window.location.href),
                })
            }
        },
        // 评论页跳转地址
        getCommentHref() {
            let cfgs = window.cfgs
            if (cfgs && cfgs.newsId && cfgs.media_id) {
                this.commentHref = `/cm/${cfgs.newsId}_${cfgs.media_id}`
            }
        },
        setCount(count) {
            let num = "";
            if (999 > count > 0) {
                num = count;
            } else if (count > 999) {
                num = `999+`;
            }
            return num;
        },
        // 获取未读消息数
        async getUnreadMessageCount() {
            let res = await getUnreadMessageCount()
            if (res?.code == 1) {
                this.showRedPotCount = res.data?.unReadTotalNum || 0
            }
        },
        handleToast(param) {
            if (!param) return
            const { toastType, toastText } = param
            const type = toastType === 'success' ? 1 : toastType === 'error' ? 2 : NaN
            window.h5_sohu.plugin.api.call('toast',
                {
                    text: toastText,
                    type: type
                },
                function () { }
            )
        },
        handleSubmit(comment){
            if(!comment) return
            this.addCommentCount()
            window?.eventBus?.$emit('addFakeComment', comment)
        }
    },
    watch: {
        isLogin(val) {
            if (!val) return
            this.getUnreadMessageCount()
            window.addEventListener('popstate', this.getUnreadMessageCount)
        }
    }
};
</script>
<style lang="less" scoped>
.comment-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 96px;
    /*px*/
    background: white;
    box-shadow: inset 0px 1px 0px 0px #ebebeb;
    border-top: 1px solid #ebebeb; /*px*/
    padding: 0 32px;
    /*px*/
    z-index: 1001;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    .avatar-container {
        position: relative;
    }

    .avatar {
        width: 56px;
        /*px*/
        height: 56px;
        /*px*/
        border-radius: 50%;
    }

    .red-pot {
        position: absolute;
        width: fit-content;
        line-height: 28px;
        /*px*/
        height: 28px;
        /*px*/
        background: #FC4B4B;
        border: 2px solid #ffffff;
        /*px*/
        display: flex;
        align-items: center;
        top: -4px;
        /* px */
        left: 42px;
        /* px */
        color: white;
        font-size: 24px;
        /* px */
        font-weight: 600;
        justify-content: center;
        width: fit-content;
        padding: 0 8px;
        /* px */
        border-radius: 13px;
        /* px */
    }

    .red-pot-little {
        width: 28px !important;
        /* px */
        padding: 0 !important;
        border-radius: 50% !important;

    }

    .line {
        height: 40px;
        /*px*/
        width: 2px;
        /*px*/
        margin: 0 20px;
        /*px*/
        background: #ebebeb;
    }

    .icons-c {
        width: 40px;
        /*px*/
        height: 40px;
        /*px*/
        position: relative;
        margin-left: 32px;

        /*px*/
        .commnet-icon {
            width: 40px;
            /*px*/
            height: 40px;
            /*px*/
            background: url('https://statics.itc.cn/mptc-mpfe/img/article/icon_comment.png');
            background-size: 100% 100%;
            position: absolute;
            right: 0;
            top: 0;
        }

        .like-icon {
            width: 40px;
            /*px*/
            height: 40px;
            /*px*/
            background: url('https://statics.itc.cn/mptc-mpfe/img/article/icon_praised.png');
            background-size: 100% 100%;
            position: absolute;
            right: 0;
            top: 0;
        }

        .no-like-icon {
            width: 40px;
            /*px*/
            height: 40px;
            /*px*/
            background: url('https://statics.itc.cn/mptc-mpfe/img/article/icon_praise_empty.png');
            background-size: 100% 100%;
            position: absolute;
            right: 0;
            top: 0;
        }

        .count {
            position: absolute;
            width: fit-content;
            transform: translate(-40%, -50%);
            height: 26px;
            /*px*/
            line-height: 26px;
            /*px*/
            height: 28px;
            /*px*/
            background: #ffd100;
            border: 2px solid #ffffff;
            /*px*/
            display: flex;
            align-items: center;
            top: 0px;
            left: 32px;
            /* px */
            color: #111111;
            font-size: 24px;
            /* px */
            padding: 0 10px;
            text-align: center;
            border-radius: 13px;
            /* px */
            box-shadow: 0 0 3px 3px #f2f2f2;
            font-weight: 700;
        }

        .plusOne {
            position: absolute;
            width: 26px;
            height: 34px;
            /*px*/
            line-height: 34px;
            /*px*/
            font-size: 24px;
            /*px*/
            font-weight: 500;
            color: #ffb619;
            opacity: 0;
        }

        .plusOneDynamic {
            top: -38px;
            animation: fadeInUp .3s ease-in-out 1;
        }

        @keyframes fadeInUp {
            from {
                opacity: 0;
                -webkit-transform: translate3d(0, 100%, 0);
                transform: translate3d(0, 100%, 0);
            }

            to {
                opacity: 1;
                -webkit-transform: translate3d(0, 0, 0);
                transform: translate3d(0, 0, 0);
            }
        }
    }

    /deep/ .comment-input-content {
        flex: 1;
        height: 72px;
        /*px*/
        display: flex;
        align-items: center;
        overflow: hidden;

        .comment-input {
            border-radius: 72px;
            /*px*/
            background: #f2f2f2;
            padding: 12px 24px;
            /*px*/
            font-size: 28px;
            /*px*/
            box-sizing: border-box;
            display: inline-flex;
            align-items: center;
            overflow: hidden;

            input {
                height: 48px;
                /*px*/
                background: #f2f2f2;
                flex: 1;
                min-width: 0PX;
                border: none;
                padding: 0;
            }

            input::placeholder {
                font-size: 28px;
                /*px*/
                line-height: 48px;
                /*px*/
                color: #757575;
            }

            .emoji-icon {
                width: 44px;
                /*px*/
                height: 44px;
                /*px*/
                background: url('../../less/images/icon_emoji_999999@2x.png');
                background-size: contain;
            }
        }
    }

    .share-icon {
        margin-left: 32px;
        /*px*/
        width: 40px;
        /*px*/
        height: 40px;
        /*px*/
        background: url('//statics.itc.cn/mptc-mpfe/img/article/icon_share_empty.png') no-repeat;
        background-size: contain;

    }
}

// 图集页
.comment-footer-album {
    border-top: none !important;
    background: #010101;
    box-shadow: inset 0px 1px 0px 0px rgba(255, 255, 255, 0.2);
    /*px*/
    color: #999;

    .line {
        background: #666;
    }

    .share-icon {
        background: url('../../less/images/icon_share@2x.png') no-repeat;
        background-size: 100% 100%;
    }

    /deep/.icons-c {
        .count {
            border: none !important;
            box-shadow: none !important;
        }

        .commnet-icon {
            background: url('../../less/images/icon_comment.png');
            background-size: 100% 100%;
        }

        .no-like-icon {
            background: url('../../less/images/icon_praise@2x.png');
            background-size: 100% 100%;
        }
    }

    /deep/ .comment-input {
        background: rgba(255, 255, 255, 0.2) !important;

        input {
            background: transparent !important;
        }

        input::placeholder {
            color: #999 !important;
        }
    }

    /deep/ .comment-pop {
        box-shadow: inset 0px 1px 0px 0px rgba(255,255,255,0.2);/*px*/
        color: #999;
        background: #010101;
        .content-container{
            background: hsla(0, 0%, 100%, .2) !important;
            border: none !important;
        }
        .editor {
            background: transparent !important;
            background: transparent;
            color: #999;
        }
        .publish-btn{
            background: hsla(0, 0%, 100%, .2);
            color: #999;
        }
        .active{
            background: #ffd100;
            color: #111;
        }
        .btn-area{
            background: transparent;
            .emoji-btn{
                background: url('../../less/images/icon_emoji_white@2x.png') no-repeat center !important;
                background-size: contain !important;
            }
            .keyboard-btn{
                background: url('../../less/images/icon_keybord_white@2x.png') no-repeat center !important;
                background-size: contain !important;
            }
            .picture-logo{
                background: url('../../less/images/icon_picture_white@2x.png') no-repeat center !important;
                background-size: contain !important;
            }
        }
        .outer-emoji{
            background: transparent;
        }
    }
}
</style>